
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-service/order-history",
      function () {
        return require("private-next-pages/customer-service/order-history.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-service/order-history"])
      });
    }
  